/**
 * TÜRKÇE ARAMA KATLAMASI.
 *
 * `toLowerCase()` TEK BAŞINA YETMEZ: JS varsayılan yerel ayarda "İ" harfini "i̇" (i + birleşen
 * nokta) yapar; kullanıcının yazdığı "i" ile eşleşmez ve "İSMAİL" araması sonuç vermez.
 * Bu yüzden önce NFD ile ayrıştırılıp birleşen işaretler atılır, sonra "ı" → "i" katlanır.
 *
 * Tek kaynak: aynı fonksiyonun kopyaları ekranlar arasında sessizce ayrışıyordu.
 */
export function fold(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/ı/g, "i");
}
